var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('span',{class:("badge " + (_vm.classes[_vm.status].class) + " " + _vm.customClass)},[_vm._v(_vm._s(_vm.classes[_vm.status].label || _vm.status))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }